export const CAMPAIGNS = ['CRM_OFFER'];
